import PageTitle from "../components/common/PageTitle";
import {PageWrapper} from "../components/common/PageWrapper";
import {useTranslation} from "react-i18next";
import AskSupport from "../components/business/support/AskSupport";

export default function SupportPage () {

    const { t } = useTranslation();

    return (

        <PageWrapper centered>

            <div className="flex space-x-12 justify-center items-center mb-10 mt-8">
                <div>
                    <img className={'w-44'} src="/assets/guestportal/help.svg" alt="Customer Help"/>
                </div>
                <div>
                    <div className={'text-2xl font-bold text-slate-700'}>
                        {t('support.supportCenter')}
                    </div>
                    <div className={'mt-1 text-lg text-slate-500'}>
                        {t('support.subTitle')}
                    </div>
                </div>
            </div>

            <div className="flex space-x-4 pt-12">
                <div className="rounded-lg shadow-xl items-center flex space-x-10 flex-1 bg-white p-6">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="text-slate-800 size-8">
                        <path
                            d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z"/>
                        <path
                            d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z"/>
                    </svg>
                    <div>
                        <div className={'text-slate-700 font-medium text-lg'}>{t('support.contactViaMail')}</div>
                        <div>
                            <a className={'text-orange-600 underline'}
                               href="mailto:help@besaferate.com">help@besaferate.com</a>
                        </div>
                    </div>
                </div>

                <div className="rounded-lg shadow-xl items-center flex space-x-10 flex-1 bg-white p-6">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="text-slate-800 size-8">
                    <path fillRule="evenodd"
                              d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                              clipRule="evenodd"/>
                    </svg>
                    <div>
                        <div className={'text-slate-700 font-medium text-lg'}>{t('support.contactViaPhone')}</div>
                        <div>
                            <a className={'text-orange-600 underline'} href="tel:0390669429163">+39 06 6942 9163</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className={'mt-6 rounded-lg bg-gray-50 border border-gray-200 p-6 shadow-xl'}>
                <div className="flex space-x-8 items-start">
                    <div>
                        <img className={'h-10'} src="/assets/share.png" alt=""/>
                    </div>
                    <div className={'flex-1'}>
                        <div className="text-2xl text-slate-800">
                            {t('support.coBrowsing')}
                        </div>
                        <div className={'mt-2 text-lg text-slate-600'}>
                            {t('support.coBrowsingSubtitle')}
                        </div>

                        <AskSupport />
                    </div>
                </div>
            </div>
        </PageWrapper>
    )

}